export const initTopParallax = () => {
  const parallaxTitle = document.querySelector(".p-top-parallax__title");
  const parallaxContainer = document.querySelector(".p-top-parallax-container");
  const firstBgImage = document.querySelector(
    ".p-top-parallax__bg-image:first-of-type"
  );
  const bgImages = document.querySelectorAll(".p-top-parallax__bg-image");

  if (!parallaxTitle || !parallaxContainer || !firstBgImage) return;

  let isInContainer = false;

  // コンテナの表示範囲を監視するObserver
  const containerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  const containerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        parallaxTitle.classList.add("is-in-container");
        isInContainer = true;
      } else {
        parallaxTitle.classList.remove("is-in-container");
        parallaxTitle.classList.remove("is-visible");
        isInContainer = false;
      }
    });
  };

  const containerObserver = new IntersectionObserver(
    containerCallback,
    containerOptions
  );
  containerObserver.observe(parallaxContainer);

  // 最初の背景画像が画面上部に到達したタイミングを監視するObserver
  const imageOptions = {
    root: null,
    rootMargin: "0px 0px -100% 0px", // 画面上部に到達したタイミングで発火
    threshold: 0,
  };

  const imageCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        parallaxTitle.classList.add("is-visible");
      }
    });
  };

  const imageObserver = new IntersectionObserver(imageCallback, imageOptions);
  imageObserver.observe(firstBgImage);

  // パララックス効果の実装
  const handleParallax = () => {
    if (!isInContainer) return;

    const containerRect = parallaxContainer.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerHeight = containerRect.height;
    const windowHeight = window.innerHeight;

    // コンテナが画面内にある場合のみパララックス効果を適用
    if (containerTop < windowHeight && containerTop + containerHeight > 0) {
      bgImages.forEach((image, index) => {
        const imageRect = image.getBoundingClientRect();
        const imageTop = imageRect.top;
        const imageHeight = imageRect.height;

        // 画像が画面内にある場合のみ計算
        if (imageTop < windowHeight && imageTop + imageHeight > 0) {
          // 各画像に異なる速度のパララックス効果を適用
          // 0.3 ~ 0.5の範囲で速度を変化させる（数値が小さいほど遅く動く）
          const speed = 0.3 + index * 0.03;
          const scrolled = windowHeight - imageTop;
          const parallaxValue = scrolled * speed;

          image.style.transform = `translateY(${parallaxValue}px)`;
        }
      });
    }
  };

  // スクロールイベントにパララックス効果を適用
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleParallax();
        ticking = false;
      });
      ticking = true;
    }
  });

  // 初期表示時にも実行
  handleParallax();
};

// ページ読み込み時に実行
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTopParallax);
} else {
  initTopParallax();
}
